const migrations = {
  1: (state) => (state),
};

export default migrations;